module.exports = __webpack_public_path__ + "static/media/21.7454fff3.jpg";